import { create } from 'zustand';
import { ThemeMode } from '../types';

interface ThemeStore {
  theme: ThemeMode;
  toggleTheme: () => void;
  setTheme: (theme: ThemeMode) => void;
}

export const useThemeStore = create<ThemeStore>((set) => {
  const stored = localStorage.getItem('theme') as ThemeMode | null;
  const initial: ThemeMode = stored || 'dark';

  // Apply initial theme
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(initial);
  }

  return {
    theme: initial,
    toggleTheme: () => {
      set((state) => {
        const newTheme: ThemeMode = state.theme === 'dark' ? 'light' : 'dark';
        localStorage.setItem('theme', newTheme);
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(newTheme);
        return { theme: newTheme };
      });
    },
    setTheme: (theme: ThemeMode) => {
      localStorage.setItem('theme', theme);
      document.documentElement.classList.remove('light', 'dark');
      document.documentElement.classList.add(theme);
      set({ theme });
    },
  };
});